<template>
  <gift-handover-gate page="gift-purchases" title="進貨管理">
    <section>
      <section class="pb-4" style="display: block;">
        <gift-list
          ref="giftList"
          :query="query"
          :readonly="true"
          @selected="onSelected"
          @updated="onRefresh"
        />
      </section>

      <section id="item" class="box">
        <gift-purchase-list
          ref="list"
          :consumable="consumable"
          :search="search"
          :gifts="selectedItems"
          @updated="onUpdated"
        />
      </section>
    </section>
  </gift-handover-gate>
</template>

<script>
import GiftHandoverGate from '@/components/gifts/GiftHandoverGate'
import GiftList from '@/components/gifts/GiftList'
import GiftPurchaseList from '@/components/gifts/GiftPurchaseList'

export default {
  name: 'Purchases',
  components: { GiftHandoverGate, GiftList, GiftPurchaseList },

  data() {
    const { query } = this.$route

    return {
      query: query,
      consumable: this.consumableType(query),
      search: query.search || '',
      selectedItems: [],

      loadingGift: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
      this.consumable = this.consumableType(this.query)
      this.search = this.query.search || ''
    }

    next()
  },
  methods: {
    consumableType(query) {
      const filterType = query.type || 'all'
      if (filterType === 'true') return true
      if (filterType === 'false') return false
      return null
    },
    onSelected(items) {
      this.selectedItems = items
    },
    async onRefresh() {
      await this.$refs.list.refresh()
    },
    async onUpdated() {
      await this.$refs.giftList.refresh()
    }
  }
}
</script>
